import "../myReports/style.scss";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {clearActiveReport, getTableauReport} from "../../actions/reports";
import {useNavigate} from "react-router-dom";
import ShowReport from "../../components/showReport";

export const route = '/error-report'

const REPORT_INFO = {
  title: 'TES Status of Invited Schools'
}

const StatusReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!activeReport) {
      dispatch(getTableauReport('getErrorReport', true));
    }
  });

  const activeReport = useSelector((state) => state.reports.activeReport);

  const onClearReport = async () => {
    await navigate('/my-data');
    await dispatch(clearActiveReport());
  };

  return (
    <div className="reports-container">
      {activeReport && <ShowReport reportInfo={REPORT_INFO} activeReport={activeReport} onReportClear={onClearReport} backToLabel='My Data'/>}
    </div>
  );
}

export default StatusReport;